export enum AdminStaffActionTypes {
  API_RESPONSE_SUCCESS = "@@admin_staffs/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@admin_staffs/API_RESPONSE_ERROR",
  CREATE_ADMIN_STAFF = "@@admin_staffs/CREATE_ADMIN_STAFF",
  EDIT_ADMIN_STAFF = "@@admin_staffs/EDIT_ADMIN_STAFF",
  DELETE_ADMIN_STAFF = "@@admin_staffs/DELETE_ADMIN_STAFF",
  GET_ADMIN_STAFF = "@@admin_staffs/GET_ADMIN_STAFF",
  GET_ADMIN_STAFF_BY_ID = "@@admin_staffs/GET_ADMIN_STAFF_BY_ID",
}
